import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { ZensoryModule } from "../../ZensoryModule";
import { LOGGER, LogLevel } from "../Util/Logger";
import { RouteId } from "../../Routes";
import { GlobalAppState } from "../AppState";
import { getEmailDomain } from "../Util/AuthHelper";
import { getRedirectUriForMSAuth } from "../Util/FirebaseHelper";

const ExchangeOAuthCodeWeb = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");
  const error = searchParams.get("error");
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  LOGGER.log(LogLevel.DEBUG, `code:::>> ${code}`);
  const userId = ZensoryModule.getAuth().getCurrentUser();

  useEffect(() => {
    async function callOAuthCode() {
      try {
        if (code && userId) {
          setLoading(true);
          const email = GlobalAppState.getUser().email;
          const subdomain = getEmailDomain(email);
          await ZensoryModule.getCalenderApi().exchangeOAuthCode({
            clientId: subdomain,
            code: code,
            userId,
            redirectUri: getRedirectUriForMSAuth(),
          });
          setLoading(false);
          await ZensoryModule.getAuth().getCurrentUserWithObserver();
          ZensoryModule.getNavigationHandler().navigate(window, RouteId.Root);
        } else {
          LOGGER.log(
            LogLevel.DEBUG,
            `ExchangeOAuthCodeWeb::Missing code or userId: code=${code}, userId=${userId}`
          );
        }
      } catch (error) {
        LOGGER.log(
          LogLevel.ERROR,
          `Error for connect caleder user: ${JSON.stringify(error)}`
        );
        ZensoryModule.getNavigationHandler().navigate(window, RouteId.Root);
      } finally {
        setLoading(false);
      }
    }
    if (code) {
      callOAuthCode();
    }
  }, [code, userId, navigate]);

  if (loading) {
    return (
      <div className="loading-container">
        <h3 style={{ color: "white", fontFamily: "Poppins" }}>Processing..</h3>
      </div>
    );
  }
  if (error || (!code && !error)) {
    setTimeout(() => {
      ZensoryModule.getNavigationHandler().navigate(window, RouteId.Root);
    }, 3000);
    return (
      <div className="loading-container">
        <h3 style={{ color: "white", fontFamily: "Poppins" }}>
          Failed to connect with Microsoft
        </h3>
      </div>
    );
  }

  return (
    <div className="loading-container">
      <h3 style={{ color: "white", fontFamily: "Poppins" }}>Logging in...</h3>
    </div>
  );
};

export default ExchangeOAuthCodeWeb;
